module.exports = __webpack_public_path__ + "static/img/productPartner_6_1.c6f32dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/productPartner_6_1.png
// module id = J+x9
// module chunks = 34